/**
 * Подложка блока-ленты: HEX из конфига секции (config.bg_color) и автоконтраст текста.
 *
 * Отдельным файлом, а не в TrendFeedSection: тот же фон и те же переменные нужны блокам,
 * которые рисуются карточками раздела (FeedBlocks), а из файла-компонента экспорт функций
 * ломает Fast Refresh (правило react-refresh/only-export-components).
 */
/** '#rgb'/'#rrggbb' → нормализованный '#rrggbb' или null (мусор = нет фона). */
export function normHex(v?: string): string | null {
	const s = String(v || '').trim()
	if (/^#[0-9a-f]{6}$/i.test(s)) return s.toLowerCase()
	if (/^#[0-9a-f]{3}$/i.test(s)) {
		const [r, g, b] = s.slice(1)
		return `#${r}${r}${g}${g}${b}${b}`.toLowerCase()
	}
	return null
}

/** Автоконтраст текста блока под HEX-фон: перекрываем локально CSS-переменные,
 *  которыми пользуются заголовок/подписи/кнопка аккордеона. */
export function contrastVars(hex: string): Record<string, string> {
	const r = parseInt(hex.slice(1, 3), 16) / 255
	const g = parseInt(hex.slice(3, 5), 16) / 255
	const b = parseInt(hex.slice(5, 7), 16) / 255
	const luma = 0.2126 * r + 0.7152 * g + 0.0722 * b
	return luma > 0.55
		? { '--text-primary': '#1f2937', '--text-muted': 'rgba(31, 41, 55, 0.62)' }
		: { '--text-primary': '#ffffff', '--text-muted': 'rgba(255, 255, 255, 0.72)' }
}
